module.exports = __webpack_public_path__ + "static_1764244025768/img/giftModule1.d7174ccf.png";